import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();
  const firstThree = categories.slice(0, 3);

  const images = [
    'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20luxury%20leather%20sneakers%20suspended%20in%20midair%20against%20a%20soft%20pastel%20pink%20gradient%20backdrop%2C%20dramatic%20studio%20lighting%20creating%20bold%20shadows%2C%20high%20fashion%20editorial%20style%2C%20minimalist%20composition%2C%20sharp%20product%20photography&width=800&height=800&seq=cat-grid-v2-shoes&orientation=squarish',
    'https://readdy.ai/api/search-image?query=An%20oversized%20forest%20green%20hoodie%20sweater%20artistically%20draped%20over%20a%20wooden%20chair%20in%20sunlit%20room%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20window%2C%20lifestyle%20fashion%20photography%2C%20cozy%20aesthetic%2C%20natural%20textures%20visible&width=800&height=800&seq=cat-grid-v2-hoodies&orientation=squarish',
    'https://readdy.ai/api/search-image?query=A%20crisp%20white%20cotton%20t-shirt%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20soft%20sage%20green%20wall%2C%20morning%20sunlight%20casting%20gentle%20shadows%2C%20Scandinavian%20aesthetic%2C%20clean%20elegant%20lifestyle%20photography%2C%20airy%20fresh%20atmosphere&width=800&height=800&seq=cat-grid-v2-tshirts&orientation=squarish',
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-foreground-600 text-base">{t('categories.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {firstThree.map((cat, idx) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-colors cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-background-100">
                <img
                  src={images[idx]}
                  alt={cat.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{cat.label}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}